

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Box, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { subscriptionGetById } from '../subscriptionPlans.service';
import { Icon } from "@iconify/react";
import Loader from '../../../../components/loader';

const SubscriptionView = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [subscriptionData, setSubscriptionData] = useState({});

    useEffect(() => {
        getSubscriptionData();
    }, []);

    const getSubscriptionData = async () => {
        try {
            const data = await subscriptionGetById(id);
            setSubscriptionData(data.data);
        } catch (error) {
            console.error('Error fetching user type by ID:', error);
            setLoading(false)
        }
    };

    return (
        <Box>
            <Grid container alignItems={'center'}>
                <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3 }}>
                    <Typography style={{ fontSize: 26, fontWeight: 700 }}>Subscription View</Typography>
                </Grid>
                <Grid size={{ xs: 6, sm: 7.5, md: 8.5, lg: 8.5, xl: 8.5 }} textAlign={'end'}>
                    <Button variant="contained" className='createBtn' type="submit" onClick={() => { setLoading(true); navigate(`/addSubcriptions/${id}?type=edit`) }}>Edit</Button>
                </Grid>
                <Grid size={{ xs: 2, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }} textAlign={'end'}>
                    <Icon icon="ei:arrow-left" onClick={() => navigate('/subscriptionPlans')} width="30" height="30" className='backIcon'  />
                </Grid>
            </Grid>

            <Grid container mt={2} rowGap={4}>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container rowGap={2}>
                        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Plane Name</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'> {subscriptionData?.planName ?? "-"} </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container rowGap={2}>
                        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Tenure</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'>  {subscriptionData?.tenure ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2}>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container rowGap={2}>
                        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Setup Fee in $ </Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'>{subscriptionData?.setupFee ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container rowGap={2}>
                        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Subscription Fee in $</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'>{subscriptionData?.subscriptionFee ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2}>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container rowGap={2}>
                        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'> User Type</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'> {subscriptionData?.userTypes?.map((type) => type?.typeName).join(', ')}</Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container rowGap={2}>
                        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'> Promo Code</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'> {subscriptionData?.promotionCode ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container mt={2}>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container alignItems={'center'} rowGap={2}>
                        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'> Description</Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                            <Typography className="contentRight" dangerouslySetInnerHTML={{ __html: subscriptionData?.description }} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                    <Grid container rowGap={2}>
                        <Grid size={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
                            <Typography className='contentLeft'>Discount Percentage </Typography>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1, md: 0.5, lg: 0.5, xl: 0.5 }}>
                            <Typography className='contentLeft'> :</Typography>
                        </Grid>
                        <Grid size={{ xs: 5, sm: 5, md: 8, lg: 8, xl: 8 }}>
                            <Typography className='contentRight'> {subscriptionData?.promotionDiscount ?? "-"}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {loading && <Loader />}
        </Box>
    );
};

export default SubscriptionView;
